import { ordersV2Api } from './Api';
import { AxiosResponse } from "axios";
import { OutsideMapResponse } from "../containers/Event/types";

const OutsideMapService = (() => {
	function getOutsideMap(eventSessionDateId: string): Promise<AxiosResponse<OutsideMapResponse>> {
		return ordersV2Api.get(`/v1/public/events/sessions/${eventSessionDateId}/outside-map`);
	}

	return {
		getOutsideMap
	}
})();

export default OutsideMapService;
